import { SearchType } from '@mews-commander/enums';
import { IconName } from '@optimus-web/icons';

export const SEARCH_TYPE_ICON_MAP = {
    [SearchType.Customer]: IconName.Profile,
    [SearchType.EnterpriseProfile]: IconName.Profile,
    [SearchType.Company]: IconName.Property,
    [SearchType.Reservation]: IconName.CustomLink,
    [SearchType.ReservationGroup]: IconName.ReservationGroup,
    [SearchType.TravelAgency]: IconName.TravelAgency,
    [SearchType.Bill]: undefined,
    [SearchType.City]: undefined,
    [SearchType.Resource]: undefined,
    [SearchType.ResourceBlock]: undefined,
    [SearchType.Locations]: undefined,
    [SearchType.Navigation]: undefined,
    [SearchType.ProductServiceOrder]: undefined,
};
